import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';

import { accessLocalStorage, createTenant, valuesAnalyze, changeViewForms, validEmail, validName } from '../../../services';

import Loading from '../../../components/Loading/LoadingModule';

import '../../../libs/bulma.min.css';
import './TenantCreate.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons';

function TenantCreate() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, toggleIsChangeFormElements } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState({});
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);
  const [tenantData, setTenantData] = useState({ name: '', tenant: '' });

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const validateUserLogged = useCallback(() => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');
    return setLoading(false);
  }, []);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber, checkPassword, isTextAndSpace } = valuesAnalyze;

    if(name === 'deleteRecDays') {
      let checkValueIsNumber = checkNumber(value);
      if(name === 'deleteRecDays' && value > 365) checkValueIsNumber = false;
      changeScreen(checkValueIsNumber, name);

      return checkValueIsNumber;
    };

    if(name === 'email') {
      const emailIsValid = validEmail(value);
      changeScreen(emailIsValid, name);
      return emailIsValid;
    }

    if(name === 'password') {
      const passwordIsValid = checkPassword(value);
      changeScreen(passwordIsValid, name);
      return passwordIsValid;
    }

    if(name === 'name' || name === 'role') {
      const checkValueIsCharacters = isTextAndSpace(value);
      changeScreen(checkValueIsCharacters, name);
      return checkValueIsCharacters;
    }

    if(name === 'deleteRecDays') {
      const checkValueIsCharacters = checkNumber(value);
      changeScreen(checkValueIsCharacters, name);
      return checkValueIsCharacters;
    }
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);
    if(Object.keys(validate).length >= 4) Object.values(validate).includes(false) ? setDisable(true) : setDisable(false);
    setValues((prevState) => prevState, values[name] = value );
    return;
  };

  const sendDataTenantGenerate = async () => {
    const fetchTenants = await createTenant(values);
    toggleIsChangeFormElements('alert-create-tenant', 'is-hidden');
    const result = Object.keys(fetchTenants).length > 0 ? true : false;
    if(result) setTenantData(fetchTenants)
    if(result) {
      setLoading(false);
      changeVisibityMessages(true, 'create-form');
      changeVisibityMessages(true, 'button-send-form');
      changeVisibityMessages(false, 'success-create-tenant');
      setTimeout(() => {
        // return history.push('/config/ramal/lista');
      }, 3000);
    };
    return;
  };

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  return (
    <div className="tenant-create-container">
      {
        loading ?
          <Loading />
        :
        <div className="tenant-create-content">
          <div className="tenant-create-header">
            <div className="tenant-create-title-wrapper">
              <svg className="tenant-create-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
              </svg>
              <div>
                <h1 className="tenant-create-title">Adicionar Cliente</h1>
                <p className="tenant-create-subtitle">Preencha os dados para criar um novo tenant</p>
              </div>
            </div>
          </div>
          <div className="alerts-section">
            <article id="alert-create-tenant" name="alert-create-tenant" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <p>Atenção!</p>
                <button className="alert-close" aria-label="delete" onClick={ () => toggleIsHidden('#alert-create-tenant') }></button>
              </div>
              <div className="alert-body">
                Não é possível gerar cliente com os campos abaixo não preenchidos.
                <br />
                Por favor, verifique os dados e clique novamente no botão <strong>Criar Cliente</strong> 
              </div>
            </article>
            <article id="error-create-tenant" name="error-create-endpoints" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <p>Erro!</p>
                <button className="alert-close" aria-label="delete" onClick={ () => toggleIsHidden('#error-create-endpoints') }></button>
              </div>
              <div className="alert-body">
                Não foi possível adicionar o cliente!
                <br />
                Verifique se o cliente já existe!
              </div>
            </article>
            <article id="success-create-tenant" name="success-create-tenant" className="alert-message alert-success is-hidden">
              <div className="alert-header">
                <p>Sucesso!</p>
                <button className="alert-close" aria-label="delete" onClick={ () => toggleIsHidden('#success-create-tenant') }></button>
              </div>
              <div className="alert-body">
                Cliente criado com <strong>sucesso</strong>!<br/>
                <strong>Nome: </strong>{ `${tenantData.name}` } - <strong>Feixe: </strong> { `${tenantData.tenant}` }
              </div>
            </article>
          </div>
          
          <div className="form-card">
            <form name="create-form" id="create-form" onSubmit={ (e) =>  e.preventDefault() }>
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">Cliente</label>
                  <div className="form-control">
                    <input className="form-input" name="name" type="text" onChange={(e) => handleChangeValues(e.target)} placeholder="Insira o nome do cliente" />
                    <p name="name-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                  </div>
                </div>
                <div className="form-field">
                  <label className="form-label">E-mail</label>
                  <div className="form-control">
                    <input className="form-input" name="email" type="text" onBlur={(e) => handleChangeValues(e.target)} placeholder="fulano@empresa.com.br" />
                    <p name="email-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">Senha</label>
                  <div className="form-control">
                    <input className="form-input" name="password" type="text" onBlur={(e) => handleChangeValues(e.target)} placeholder="Tamanho mínimo 6 caract. (@!#$&)"/>
                    <p name="password-invalid-data" className='form-error is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                  </div>
                </div>
                <div className="form-field">
                  <label className="form-label">Tempo de Gravação (dias)</label>
                  <div className="form-control">
                    <input className="form-input" name="deleteRecDays" type="number" onChange={(e) => handleChangeValues(e.target)} placeholder="Máximo 365 dias"/>
                    <p name="deleteRecDays-invalid-data" className='form-error is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                  </div>
                </div>
                <div className="form-field">
                  <label className="form-label">Tipo</label>
                  <div className="form-control">
                    <select className="form-select" name="role" onChange={(e) => handleChangeValues(e.target)} >
                      <option value="">Selecione</option>
                      <option value="root">Técnico</option>
                      <option value="admin">Admin</option>
                      <option value="user">Usuário</option>
                    </select>
                    <p name="role-invalid-data" className='form-error is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                  </div>
                </div>
              </div>
            </form>
            
            <div id="button-send-form" name="button-send-form" className="form-actions">
              <button className="btn-submit" type="submit" onClick={ () => sendDataTenantGenerate() }>
                <FontAwesomeIcon icon={ faPhoneSquare } fixedWidth />
                <span>Criar Cliente</span>
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default TenantCreate;
